<div class="modal-shell">
  <header class="modal-header__shell">
    <button (click)="closeModal()">
      <ids-icon mat-dialog-close aria-label="fechar modal" size="M">
        fechar
      </ids-icon>
    </button>
    <h2 *ngIf="data && data.titulo_modal && !showError" class="modal-title" mat-dialog-title>{{ data.titulo_modal }}</h2>
  </header>
  
  <app-microfrontend-error [errorCode]="errorCode" class="showError" *ngIf="showError"></app-microfrontend-error>
  
  <ng-container *ngIf="!showError">
    <ids-loading *ngIf="isLoading"></ids-loading>
  
    <div id="modal-{{data.tag_html}}"></div>
  </ng-container>
</div>